var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      ref: "dailyModelDialog",
      attrs: { height: "90vh", width: "700px" },
      model: {
        value: _vm.DailyModel.dailyModal,
        callback: function ($$v) {
          _vm.$set(_vm.DailyModel, "dailyModal", $$v)
        },
        expression: "DailyModel.dailyModal",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { width: "100%", "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { width: "100%" } },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-row", { attrs: { justify: "center" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "primary--text",
                            attrs: { align: "center" },
                          },
                          [
                            !_vm.saveMode
                              ? _c("h1", [
                                  _vm._v(_vm._s(_vm.$t("newDailyModel"))),
                                ])
                              : _c("h1", [
                                  _vm._v(_vm._s(_vm.$t("editDailyModel"))),
                                ]),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { "justify-space-between": "", row: "" },
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { grow: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              counter: 50,
                              disabled: _vm.DailyModel.locked,
                              label: _vm.$t("timemodelName"),
                              rules: _vm.dailyModelNameRules,
                              required: "",
                            },
                            model: {
                              value: _vm.DailyModel.dailyModelName,
                              callback: function ($$v) {
                                _vm.$set(_vm.DailyModel, "dailyModelName", $$v)
                              },
                              expression: "DailyModel.dailyModelName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "ml-3", attrs: { shrink: "" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              ref: "dialog",
                              attrs: {
                                disabled: _vm.DailyModel.locked,
                                "return-value": _vm.DailyModel.dailyTime,
                                persistent: "",
                                width: "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel,
                                    "dailyTime",
                                    $event
                                  )
                                },
                                "update:return-value": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel,
                                    "dailyTime",
                                    $event
                                  )
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.DailyModel.locked ||
                                                !_vm.DailyModel.flexTime,
                                              label: _vm.$t("debitWorkTime"),
                                              "prepend-icon":
                                                "mdi-clock-outline",
                                              readonly:
                                                !_vm.DailyModel.flexTime,
                                            },
                                            model: {
                                              value: _vm.DailyModel.dailyTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DailyModel,
                                                  "dailyTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DailyModel.dailyTime",
                                            },
                                          },
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.DailyModel.dailyTimeModal,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.DailyModel,
                                    "dailyTimeModal",
                                    $$v
                                  )
                                },
                                expression: "DailyModel.dailyTimeModal",
                              },
                            },
                            [
                              _vm.DailyModel.dailyTimeModal
                                ? _c(
                                    "v-time-picker",
                                    {
                                      attrs: {
                                        color: "primary",
                                        disabled: _vm.DailyModel.locked,
                                        format: "24hr",
                                        readonly: !_vm.DailyModel.flexTime,
                                      },
                                      model: {
                                        value: _vm.DailyModel.dailyTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DailyModel,
                                            "dailyTime",
                                            $$v
                                          )
                                        },
                                        expression: "DailyModel.dailyTime",
                                      },
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled: _vm.DailyModel.locked,
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.DailyModel.dailyTimeModal = false
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            disabled: _vm.DailyModel.locked,
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$refs.dialog.save(
                                                _vm.DailyModel.dailyTime
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("OK")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-switch", {
                    attrs: { label: _vm.$t("flexTime") },
                    model: {
                      value: _vm.DailyModel.flexTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.DailyModel, "flexTime", $$v)
                      },
                      expression: "DailyModel.flexTime",
                    },
                  }),
                  _c(
                    "v-layout",
                    {
                      staticClass: "mt-3 pa-0",
                      attrs: { column: "", "justify-center": "" },
                    },
                    [
                      _c("v-subheader", { staticClass: "pb-3" }, [
                        _vm._v(_vm._s(_vm.$t("worktime"))),
                      ]),
                      _c(
                        "v-layout",
                        { attrs: { "justify-space-between": "", row: "" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              ref: "startFromdialog",
                              attrs: {
                                "return-value": _vm.DailyModel.startFromTime,
                                persistent: "",
                                width: "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel,
                                    "startFromTime",
                                    $event
                                  )
                                },
                                "update:return-value": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel,
                                    "startFromTime",
                                    $event
                                  )
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              disabled: _vm.DailyModel.locked,
                                              label: _vm.DailyModel
                                                .dailyTimeIsFlexible
                                                ? "Kommen von"
                                                : _vm.$t("coming"),
                                              "prepend-icon":
                                                "mdi-clock-outline",
                                              "append-icon": "mdi-close",
                                              rules: _vm.timeRules,
                                              readonly: "",
                                            },
                                            on: {
                                              "click:append": function (
                                                $event
                                              ) {
                                                _vm.DailyModel.startFromTime =
                                                  ""
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.DailyModel.startFromTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DailyModel,
                                                  "startFromTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DailyModel.startFromTime",
                                            },
                                          },
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.DailyModel.startFromTimeModal,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.DailyModel,
                                    "startFromTimeModal",
                                    $$v
                                  )
                                },
                                expression: "DailyModel.startFromTimeModal",
                              },
                            },
                            [
                              _vm.DailyModel.startFromTimeModal
                                ? _c(
                                    "v-time-picker",
                                    {
                                      attrs: {
                                        color: "primary",
                                        disabled: _vm.DailyModel.locked,
                                        format: "24hr",
                                      },
                                      model: {
                                        value: _vm.DailyModel.startFromTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DailyModel,
                                            "startFromTime",
                                            $$v
                                          )
                                        },
                                        expression: "DailyModel.startFromTime",
                                      },
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.DailyModel.startFromTimeModal = false
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$refs.startFromdialog.save(
                                                _vm.DailyModel.startFromTime
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("OK")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.DailyModel.dailyTimeIsFlexible
                            ? _c(
                                "v-dialog",
                                {
                                  ref: "startTodialog",
                                  attrs: {
                                    "return-value": _vm.DailyModel.startToTime,
                                    persistent: "",
                                    width: "290px",
                                  },
                                  on: {
                                    "update:returnValue": function ($event) {
                                      return _vm.$set(
                                        _vm.DailyModel,
                                        "startToTime",
                                        $event
                                      )
                                    },
                                    "update:return-value": function ($event) {
                                      return _vm.$set(
                                        _vm.DailyModel,
                                        "startToTime",
                                        $event
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.DailyModel
                                                        .dailyTimeIsFlexible,
                                                    label: "Kommen bis",
                                                    "prepend-icon":
                                                      "mdi-clock-outline",
                                                    readonly: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.DailyModel
                                                        .startToTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.DailyModel,
                                                        "startToTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "DailyModel.startToTime",
                                                  },
                                                },
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2714768925
                                  ),
                                  model: {
                                    value: _vm.DailyModel.startToTimeModal,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DailyModel,
                                        "startToTimeModal",
                                        $$v
                                      )
                                    },
                                    expression: "DailyModel.startToTimeModal",
                                  },
                                },
                                [
                                  _vm.DailyModel.startToTimeModal
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            color: "primary",
                                            min: _vm.DailyModel.startFromTime,
                                            disabled: _vm.DailyModel.locked,
                                            format: "24hr",
                                          },
                                          model: {
                                            value: _vm.DailyModel.startToTime,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.DailyModel,
                                                "startToTime",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "DailyModel.startToTime",
                                          },
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.DailyModel.startToTimeModal = false
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$refs.startTodialog.save(
                                                    _vm.DailyModel.startToTime
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("OK")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { "justify-space-between": "", row: "" } },
                        [
                          _c(
                            "v-dialog",
                            {
                              ref: "endFromdialog",
                              attrs: {
                                "return-value": _vm.DailyModel.endFromTime,
                                persistent: "",
                                width: "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel,
                                    "endFromTime",
                                    $event
                                  )
                                },
                                "update:return-value": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel,
                                    "endFromTime",
                                    $event
                                  )
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              disabled: _vm.DailyModel.locked,
                                              label: _vm.DailyModel
                                                .dailyTimeIsFlexible
                                                ? "Gehen von"
                                                : _vm.$t("going"),
                                              "prepend-icon":
                                                "mdi-clock-outline",
                                              rules: _vm.timeRules,
                                              "append-icon": "mdi-close",
                                              readonly: "",
                                            },
                                            on: {
                                              "click:append": function (
                                                $event
                                              ) {
                                                _vm.DailyModel.endFromTime = ""
                                              },
                                            },
                                            model: {
                                              value: _vm.DailyModel.endFromTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.DailyModel,
                                                  "endFromTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "DailyModel.endFromTime",
                                            },
                                          },
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.DailyModel.endFromTimeModal,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.DailyModel,
                                    "endFromTimeModal",
                                    $$v
                                  )
                                },
                                expression: "DailyModel.endFromTimeModal",
                              },
                            },
                            [
                              _vm.DailyModel.endFromTimeModal
                                ? _c(
                                    "v-time-picker",
                                    {
                                      attrs: {
                                        color: "primary",
                                        disabled: _vm.DailyModel.locked,
                                        min: _vm.endFromMinTime,
                                        format: "24hr",
                                      },
                                      model: {
                                        value: _vm.DailyModel.endFromTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DailyModel,
                                            "endFromTime",
                                            $$v
                                          )
                                        },
                                        expression: "DailyModel.endFromTime",
                                      },
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.DailyModel.endFromTimeModal = false
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$refs.endFromdialog.save(
                                                _vm.DailyModel.endFromTime
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("OK")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.DailyModel.dailyTimeIsFlexible
                            ? _c(
                                "v-dialog",
                                {
                                  ref: "endTodialog",
                                  attrs: {
                                    "return-value": _vm.DailyModel.endToTime,
                                    disabled: _vm.DailyModel.locked,
                                    persistent: "",
                                    width: "290px",
                                  },
                                  on: {
                                    "update:returnValue": function ($event) {
                                      return _vm.$set(
                                        _vm.DailyModel,
                                        "endToTime",
                                        $event
                                      )
                                    },
                                    "update:return-value": function ($event) {
                                      return _vm.$set(
                                        _vm.DailyModel,
                                        "endToTime",
                                        $event
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.DailyModel
                                                        .dailyTimeIsFlexible,
                                                    label: "Gehen bis",
                                                    "prepend-icon":
                                                      "mdi-clock-outline",
                                                    readonly: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.DailyModel.endToTime,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.DailyModel,
                                                        "endToTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "DailyModel.endToTime",
                                                  },
                                                },
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3470117116
                                  ),
                                  model: {
                                    value: _vm.DailyModel.endToTimeModal,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.DailyModel,
                                        "endToTimeModal",
                                        $$v
                                      )
                                    },
                                    expression: "DailyModel.endToTimeModal",
                                  },
                                },
                                [
                                  _vm.DailyModel.endToTimeModal
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            color: "primary",
                                            min: _vm.DailyModel.endFromTime,
                                            disabled: _vm.DailyModel.locked,
                                            format: "24hr",
                                          },
                                          model: {
                                            value: _vm.DailyModel.endToTime,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.DailyModel,
                                                "endToTime",
                                                $$v
                                              )
                                            },
                                            expression: "DailyModel.endToTime",
                                          },
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.DailyModel.endToTimeModal = false
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$refs.endTodialog.save(
                                                    _vm.DailyModel.endToTime
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("OK")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-layout",
                    {
                      staticClass: "mt-3 pa-0",
                      attrs: { column: "", "justify-center": "" },
                    },
                    [
                      _c("v-subheader", [_vm._v(_vm._s(_vm.$t("pauses")))]),
                      _c("v-checkbox", {
                        staticClass: "ma-0 pa-0",
                        attrs: {
                          color: "primary",
                          disabled: _vm.DailyModel.locked,
                          label: _vm.$t("fixedBreakTimes"),
                        },
                        model: {
                          value: _vm.DailyModel.fixedBreakTimes,
                          callback: function ($$v) {
                            _vm.$set(_vm.DailyModel, "fixedBreakTimes", $$v)
                          },
                          expression: "DailyModel.fixedBreakTimes",
                        },
                      }),
                      !_vm.DailyModel.fixedBreakTimes
                        ? _c(
                            "v-dialog",
                            {
                              ref: "pauseDurationDialog",
                              attrs: {
                                "return-value":
                                  _vm.DailyModel.dailyPauses[0].pauseDuration,
                                disabled: _vm.DailyModel.locked,
                                persistent: "",
                                width: "290px",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel.dailyPauses[0],
                                    "pauseDuration",
                                    $event
                                  )
                                },
                                "update:return-value": function ($event) {
                                  return _vm.$set(
                                    _vm.DailyModel.dailyPauses[0],
                                    "pauseDuration",
                                    $event
                                  )
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                label:
                                                  _vm.$t("totalBreakTime") +
                                                  " " +
                                                  _vm.$t("infoForUser"),
                                                "prepend-icon":
                                                  "mdi-clock-outline",
                                                "append-icon": "mdi-close",
                                                readonly: "",
                                              },
                                              on: {
                                                "click:append": function (
                                                  $event
                                                ) {
                                                  _vm.DailyModel.dailyPauses[0].pauseDuration =
                                                    ""
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.DailyModel.dailyPauses[0]
                                                    .pauseDuration,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.DailyModel
                                                      .dailyPauses[0],
                                                    "pauseDuration",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "DailyModel.dailyPauses[0].pauseDuration",
                                              },
                                            },
                                            on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2900376040
                              ),
                              model: {
                                value:
                                  _vm.DailyModel.dailyPauses[0]
                                    .pauseDurationModal,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.DailyModel.dailyPauses[0],
                                    "pauseDurationModal",
                                    $$v
                                  )
                                },
                                expression:
                                  "DailyModel.dailyPauses[0].pauseDurationModal",
                              },
                            },
                            [
                              _vm.DailyModel.dailyPauses[0].pauseDurationModal
                                ? _c(
                                    "v-time-picker",
                                    {
                                      attrs: {
                                        color: "primary",
                                        format: "24hr",
                                        disabled: _vm.DailyModel.locked,
                                      },
                                      model: {
                                        value:
                                          _vm.DailyModel.dailyPauses[0]
                                            .pauseDuration,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.DailyModel.dailyPauses[0],
                                            "pauseDuration",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "DailyModel.dailyPauses[0].pauseDuration",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.DailyModel.dailyPauses[0].pauseDurationModal = false
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$refs.pauseDurationDialog.save(
                                                _vm.DailyModel.dailyPauses[0]
                                                  .pauseDuration
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("OK")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.DailyModel.dailyPauses, function (pause, id) {
                        return _c(
                          "v-layout",
                          {
                            key: id,
                            staticClass: "ma-0 pa-0",
                            attrs: { "justify-space-between": "", row: "" },
                          },
                          [
                            _vm.DailyModel.fixedBreakTimes
                              ? _c(
                                  "v-dialog",
                                  {
                                    ref: "pauseFromDialog",
                                    refInFor: true,
                                    attrs: {
                                      disabled: _vm.DailyModel.locked,
                                      persistent: "",
                                      width: "290px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "320px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          label:
                                                            _vm.$t("pause") +
                                                            " " +
                                                            pause.id +
                                                            " " +
                                                            _vm.$t("from"),
                                                          "append-icon":
                                                            "mdi-close",
                                                          readonly: "",
                                                        },
                                                        on: {
                                                          "click:append":
                                                            function ($event) {
                                                              pause.pauseStartTime =
                                                                ""
                                                            },
                                                        },
                                                        model: {
                                                          value:
                                                            pause.pauseStartTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              pause,
                                                              "pauseStartTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pause.pauseStartTime",
                                                        },
                                                      },
                                                      on
                                                    )
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: pause.pauseFromModal,
                                      callback: function ($$v) {
                                        _vm.$set(pause, "pauseFromModal", $$v)
                                      },
                                      expression: "pause.pauseFromModal",
                                    },
                                  },
                                  [
                                    pause.pauseFromModal
                                      ? _c(
                                          "v-time-picker",
                                          {
                                            attrs: {
                                              color: "primary",
                                              min: _vm.DailyModel.startFromTime,
                                              max: pause.pauseEndTime,
                                              disabled: _vm.DailyModel.locked,
                                              format: "24hr",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.timeChanged()
                                              },
                                            },
                                            model: {
                                              value: pause.pauseStartTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  pause,
                                                  "pauseStartTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pause.pauseStartTime",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    pause.pauseFromModal = false
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    pause.pauseFromModal = false
                                                  },
                                                },
                                              },
                                              [_vm._v("OK")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.DailyModel.fixedBreakTimes
                              ? _c(
                                  "v-dialog",
                                  {
                                    ref: "pauseToDialog",
                                    refInFor: true,
                                    attrs: { persistent: "", width: "290px" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "320px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          label:
                                                            _vm.$t("pause") +
                                                            " " +
                                                            pause.id +
                                                            " " +
                                                            _vm.$t("until"),
                                                          "append-icon":
                                                            "mdi-close",
                                                          readonly: "",
                                                        },
                                                        on: {
                                                          "click:append":
                                                            function ($event) {
                                                              pause.pauseEndTime =
                                                                ""
                                                            },
                                                        },
                                                        model: {
                                                          value:
                                                            pause.pauseEndTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              pause,
                                                              "pauseEndTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pause.pauseEndTime",
                                                        },
                                                      },
                                                      on
                                                    )
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: pause.pauseToModal,
                                      callback: function ($$v) {
                                        _vm.$set(pause, "pauseToModal", $$v)
                                      },
                                      expression: "pause.pauseToModal",
                                    },
                                  },
                                  [
                                    pause.pauseToModal
                                      ? _c(
                                          "v-time-picker",
                                          {
                                            attrs: {
                                              color: "primary",
                                              min: pause.pauseStartTime,
                                              max: _vm.DailyModel.endFromTime,
                                              format: "24hr",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.timeChanged()
                                              },
                                            },
                                            model: {
                                              value: pause.pauseEndTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  pause,
                                                  "pauseEndTime",
                                                  $$v
                                                )
                                              },
                                              expression: "pause.pauseEndTime",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    pause.pauseToModal = false
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(_vm.$t("cancel")))]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { color: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    pause.pauseToModal = false
                                                  },
                                                },
                                              },
                                              [_vm._v("OK")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _c("v-textarea", {
                    staticClass: "pb-2",
                    attrs: {
                      name: "input-7-1",
                      label: _vm.$t("remark"),
                      counter: 254,
                      rules: _vm.remarkRules,
                      disabled: _vm.DailyModel.locked,
                    },
                    model: {
                      value: _vm.DailyModel.dailyModelText,
                      callback: function ($$v) {
                        _vm.$set(_vm.DailyModel, "dailyModelText", $$v)
                      },
                      expression: "DailyModel.dailyModelText",
                    },
                  }),
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "", "justify-center": "" } },
                    [
                      !_vm.saveMode
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "buttonHoverOpacity",
                              attrs: { color: "primary" },
                              on: { click: _vm.addTimeModel },
                            },
                            [_vm._v(_vm._s(_vm.$t("addDailyModel")))]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "buttonHoverOpacity",
                              attrs: { color: "primary" },
                              on: { click: _vm.saveTimeModel },
                            },
                            [_vm._v(_vm._s(_vm.$t("saveDailyModel")))]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }